import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-fm-button-loading',
  templateUrl: './button-loading.component.html',
})
export class ButtonLoadingComponent {
  @Input() prefix = '';

  get classNames() {
    return [
      `${this.prefix}loading-spinner`,
      `${this.prefix}loading-spinner--light`,
    ].join(' ');
  }
}
